/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { createAction } from 'redux-actions';
import { setSettings } from '@nebula/airglow-plugin-unified-shell';

export const LOADED_FEATURE_FLAGS = 'gemini/LOADED_FEATURE_FLAGS';
export const STATEFUL_ERROR = 'gemini/STATEFUL_ERROR';
export const STATEFUL_INIT = 'gemini/STATEFUL_INIT';
export const STATEFUL_INITED = 'gemini/STATEFUL_INITED';
export const STATEFUL_NAVIGATION = 'gemini/STATEFUL_NAVIGATION';
export const STATEFUL_PLUGIN_SAVED = 'gemini/STATEFUL_PLUGIN_SAVED';
export const STATEFUL_RESET = 'gemini/STATEFUL_RESET';

export const NAVIGATE_TO_SESSION_LIST = 'session/NAVIGATE_TO_SESSION_LIST';
export const NAVIGATE_TO_SESSION_VIEW = 'session/NAVIGATE_TO_SESSION_VIEW';
export const NAVIGATE_TO_SESSION_VIEW_SELECTED = 'session/NAVIGATE_TO_SESSION_VIEW_SELECTED';

export const navigateToSessionList = createAction(NAVIGATE_TO_SESSION_LIST);
export const navigateToSessionView = createAction(NAVIGATE_TO_SESSION_VIEW);
export const navigateToSessionViewSelected = createAction(NAVIGATE_TO_SESSION_VIEW_SELECTED);

export const loadedFeatureFlags = createAction(LOADED_FEATURE_FLAGS);
export const statefulError = createAction(STATEFUL_ERROR);
export const statefulInit = createAction(STATEFUL_INIT);
export const statefulInited = createAction(STATEFUL_INITED);
export const statefulNavigation = createAction(STATEFUL_NAVIGATION);
export const statefulPluginSaved = createAction(STATEFUL_PLUGIN_SAVED);
export const statefulReset = createAction(STATEFUL_RESET);

export const writeRecentSessionsToUser = value => setSettings({
  groupId: 'griffon',
  settings: { recentSessions: value },
  level: 'user'
});

export const writeSessionSettingsToSession = value => setSettings({
  groupId: 'griffon',
  settings: { sessionSettings: value },
  level: 'org'
});

export const writeValidationluginSettingsToOrg = value => setSettings({
  groupId: 'griffon',
  settings: { validationPlugins: value },
  level: 'org'
});

export const writeValidationluginSettingsToUser = value => setSettings({
  groupId: 'griffon',
  settings: { validationPlugins: value },
  level: 'userorg'
});

export const writeViewPluginToOrg = value => setSettings({
  groupId: 'griffon',
  settings: { enabledViewPlugins: value },
  level: 'org'
});

export const writeViewPluginToUser = value => setSettings({
  groupId: 'griffon',
  settings: { enabledViewPlugins: value },
  level: 'userorg'
});

export const writeWorkspaceToOrg = value => setSettings({
  groupId: 'griffon',
  settings: { workspaces: value },
  level: 'org'
});

export const writeWorkspaceToUser = value => setSettings({
  groupId: 'griffon',
  settings: { workspaces: value },
  level: 'userorg'
});
